export default __webpack_public_path__ + "static/media/kedi-oturan.0e7c7d14.png";